<template>
  <Modal
    :show="show"
    width="366"
    cancel-text=""
    action-text=""
    @close="$emit('close')"
  >
    <template #title>
      <span class="text-h2">Delete Job Family</span>
    </template>
    <template #content>
      <p class="text-body-1 text-textDarkest mb-0">
        {{ bodyLine }}
      </p>
    </template>
    <template #actions>
      <DpplNewButton
        class="bulk-modal-action delete-action text-button-1"
        variant="outlined"
        :loading="loading"
        @click="$emit('confirm')"
      >
        Delete
      </DpplNewButton>
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import Modal from '@/components/shared/Modal.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import { formatFamilyUsage } from '@/components/jobArchitecture/helpers';

const props = defineProps({
  show: { type: Boolean, default: false },
  familyName: { type: String, default: '' },
  profileCount: { type: Number, default: 0 },
  draftCount: { type: Number, default: 0 },
  loading: { type: Boolean, default: false },
});

defineEmits(['close', 'confirm']);

const bodyLine = computed(() => {
  const usage = formatFamilyUsage({
    profileCount: props.profileCount,
    draftCount: props.draftCount,
  });

  if (!usage) {
    return `${props.familyName} has no job profiles or drafts.`;
  }

  return `${props.familyName} is assigned to ${usage}. They'll become uncategorized.`;
});
</script>

<style scoped lang="less">
.bulk-modal-action {
  width: 150px;
  height: 40px !important;
  min-height: 40px !important;
}

.delete-action {
  border: 1px solid @stroke-default;
  background: @white;
  color: @text-error;
}
</style>
